module.exports = "/images/resource-image-win.png?2da0455b4eb8b2f31671ec93ef3a463f";